
<template>
  <div v-wechat-title="this.$store.state.shop" class="page-group bff">
    <div class="page page-current">
      <card-header ref="header" @handleInit="handleInit" @handleChangeType="handleChangeType" @changeForm="handleChangeForm"/>
      <v-scroll v-if="show" :on-refresh="onRefresh" :on-infinite="onInfinite" :is-total="isTotal">
        <finance-report v-if="card_type === 'finance'" :data="data"/>
        <manage-report v-if="card_type === 'manage'" :data="data"/>
        <store-list :list-data="listData" :card-type="card_type"/>
      </v-scroll>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import financeReport from "./components/report/finance";
import manageReport from "./components/report/manage";
import cardHeader from "./components/header/header";
import storeList from "./components/list/store-list";
import Scroll from "@/components/scroll";
import Moment from 'moment'
import { getStoresList, getManageStoresList, getManageGroupList, getOperatingGroupList } from "@/api/order";
import { getTime, getApiJson, setApiJson, setMcRcJson, setMcRdJson, setMcChargeJson} from "@/libs/auth.js";
export default {
  components: { cardHeader, financeReport, manageReport, storeList, "v-scroll": Scroll },
  data () {
    return {
      card_type: "finance",
      listData: [],
      form: {
        start: null,
        end: null,
        sort_by: 'revenue',
        order: 'desc',
        type: 'month',
        date: `${new Date().getFullYear()}${new Date().getMonth() < 10 ? '0'+new Date().getMonth() : new Date().getMonth()}`
      },
      data: null,
      show: false,
      page: {
        total: 0,
        size: 10,
        current: 1
      },
      isTotal: false,
      flag: true
    }
  },
  mounted () {
    this.handleInit(JSON.parse(getApiJson()) || this.form);
  },
  methods: {
    handleInit (form) {
      this.listData = [];
      this.show = false;
      $.showIndicator();
      if (this.card_type === "finance" && this.$route.query.position != 3) {
        getManageStoresList(form).then(res => {
          this.listData = res.data.stores;
          this.data = res.data;
          setMcRcJson(JSON.stringify(res.data));
          setMcRdJson(JSON.stringify(res.data));
          $.hideIndicator();
        }).finally(() => {
          this.show = true;
          this.isTotal = false;
        }).catch(res => {
          this.data = null;
          this.listData = [];
          $.hideIndicator();
        });
      } else if (this.card_type === "finance" && this.$route.query.position == 3) {
        getManageGroupList(form).then(res => {
          this.listData = res.data.stores;
          this.data = res.data;
          setMcRcJson(JSON.stringify(res.data));
          setMcRdJson(JSON.stringify(res.data));
          $.hideIndicator();
        }).finally(() => {
          this.show = true;
          this.isTotal = false;
        }).catch(res => {
          this.data = null;
          this.listData = [];
          $.hideIndicator();
        });
      } else if (this.card_type === "manage" && this.$route.query.position != 3) {
        getStoresList(JSON.parse(getApiJson()) || this.form).then(res => {
          this.listData = res.data.stores;
          this.data = res.data;
          setMcChargeJson(JSON.stringify(res.data));
          $.hideIndicator();
        }).finally(() => {
          this.isTotal = false;
          this.show = true;
        }).catch(res => {
          this.data = null;
          this.listData = [];
          $.hideIndicator();
        });
      } else if (this.card_type === "manage" && this.$route.query.position == 3) {
        getOperatingGroupList(JSON.parse(getApiJson()) || this.form).then(res => {
          this.listData = res.data.stores;
          this.data = res.data;
          setMcChargeJson(JSON.stringify(res.data));
          $.hideIndicator();
        }).finally(() => {
          this.isTotal = false;
          this.show = true;
        }).catch(res => {
          this.data = null;
          this.listData = [];
          $.hideIndicator();
        });
      }
    },
    handleChangeType (v) {
      this.card_type = v;
      this.page.current = 1;
      this.handleInit(JSON.parse(getApiJson()) || this.form);
    },
    onRefresh (done) {
      this.handleInit(JSON.parse(getApiJson()) || this.form);
      done(); // call done
    },
    onInfinite (done) {
      this.page.current++;

      if (this.listData.length >= parseInt(this.page.total)) {
        this.$el.querySelector(".load-more").style.display = "none";
        this.page.current = 1;
        return false;
      }
      if (this.card_type === "finance" && this.$route.query.position != 3) {
        getManageStoresList(this.start, this.end, this.page.current)
          .then(res => {
            res.data.stores.forEach(item => {
              this.listData.push(item);
            });
            done();
          })
          .catch(res => {
            this.listData = [];
          });
      } else if (this.card_type === "finance" && this.$route.query.position == 3) {
        getManageGroupList(this.start, this.end, this.page.current)
          .then(res => {
            res.data.stores.forEach(item => {
              this.listData.push(item);
            });
            done();
          })
          .catch(res => {
            this.listData = [];
          });
      } else if (this.card_type === "manage" && this.$route.query.position != 3) {
        getStoresList(this.start, this.end, this.page.current)
          .then(res => {
            res.data.stores.forEach(item => {
              this.listData.push(item);
            });
            done();
          })
          .catch(res => {
            this.listData = [];
          });
      } else if (this.card_type === "manage" && this.$route.query.position == 3) {
        getOperatingGroupList(this.start, this.end, this.page.current)
          .then(res => {
            res.data.stores.forEach(item => {
              this.listData.push(item);
            });
            done();
          })
          .catch(res => {
            this.listData = [];
          });
      }
    },
    handleChangeForm(obj) {
      this.form = obj
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.flag) {
      next();
    } else {
      if (from.path !== "store") {
        next();
      }
      $.closeModal(".popup-time");
      this.flag = true;
      this.$router.push({ path: "store" });
    }
  }
};
</script>

<style lang="less" scoped>
.page-group {
  z-index: 10700;
}
</style>

